module.exports = __webpack_public_path__ + "static/media/declined.bf640f89.svg";